import React from 'react';
import { HeroSection } from './components/HeroSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen flex flex-col bg-[#0a0f1a]" data-id="element-0">
      <div className="flex-grow" data-id="element-1">
        <HeroSection data-id="element-2" />
      </div>
      <Footer data-id="element-3" />
    </div>;
}